import { format } from "date-fns";
import { LogPage } from "../../../crud/logs/types";
import { MetricsPage } from "../../../crud/metrics/types";
import { TimeRange } from "../types";
import { ClusterFrontendSchema } from "../../../api-client";
import { REFRESH_METRICS_INTERVAL } from "./const";

export const timeRangeToString = (timeRange: TimeRange): string =>
  format(new Date(timeRange[0]), "HH:mm:ss") +
  "–" +
  format(new Date(timeRange[1]), "HH:mm:ss");

export const getLatestTimestamp = (
  pages?: LogPage[] | MetricsPage[],
): number | undefined => {
  const timestamps = pages?.flatMap((page) =>
    page.data?.map(({ timestamp }) => timestamp),
  );
  if (!timestamps?.length) {
    return undefined;
  }
  // using timestamps.reduce rather than Math.max(...timestamps) to avoid
  // putting timestamps on the callstack (which can cause Maximum call stack size exceeded)
  const latestTimestamp =
    timestamps && timestamps.reduce((a, b) => Math.max(a, b), -Infinity);
  return latestTimestamp;
};
export const getDefaultTimeRange = (
  cluster: ClusterFrontendSchema | undefined,
): TimeRange | undefined => {
  if (!cluster) {
    return undefined;
  }
  const defaultSinceMs = new Date(cluster.created).getTime();
  // Show metrics until now, or when cluster entered terminal state
  const defaultUntilMs = cluster.finishedAt
    ? new Date(cluster.finishedAt).getTime() + REFRESH_METRICS_INTERVAL
    : Date.now();

  return [defaultSinceMs, defaultUntilMs];
};
